export function parseDate(date) {
  return (
    date.getFullYear() +
    '-' +
    fill(1 + date.getMonth()) +
    '-' +
    fill(date.getDate())
  )
}

function fill(str) {
  if (str.toString().length === 1) return '0' + str
  return str
}




// WEBPACK FOOTER //
// ./src/helpers/Functions/index.js